export const DEFAULT_BUTTON_CLASSES = ['flex', 'flex-row', 'items-center'].join(' ');

export const PRIMARY_CLASSES = [
  'bg-primary-blue',
  'rounded-[10px]',
  'h-10',
  'px-6',
  'justify-center',
  'hover:shadow-primary'
].join(' ');

export const SECONDARY_CLASSES = [
  'h-10',
  'px-4',
  'text-primary-blue',
  'justify-center',
  'hover:shadow-primary',
  'rounded-[10px]',
  'text-primary-blue',
  'border',
  'border-primary-blue'
].join(' ');

export const TERTIARY_CLASSES = ['justify-center'].join(' ');

export const SIDEBAR_CLASSES = [
  'bg-primary-gray',
  'hover:text-primary-blue',
  'h-10',
  'w-full',
  'justify-start'
].join(' ');

export const ARROW_CLASSES = [
  'bg-primary-blue',
  'hover:bg-primary-white',
  'rounded-l-lg',
  'justify-center',
  'w-6',
  'h-6'
].join(' ');

export const ICON_PRIMARY_CLASSES = [
  'border',
  'border-primary-blue',
  'bg-primary-white',
  'hover:shadow-primary',
  'rounded-[5px]',
  'md:rounded-[10px]',
  'justify-center',
  'w-[30px]',
  'h-[30px]',
  'md:w-10',
  'md:h-10'
].join(' ');

export const ICON_SECONDARY_CLASSES = ['w-6', 'h-6'].join(' ');

export const DISABLED_BUTTON_CLASSES = [
  'cursor-auto',
  '!hover:shadow-none',
  '!shadow-none',
  'border-secondary-steel-blue'
].join(' ');

export const LINK_BUTTON_CLASSES = ['border-none', 'text-primary-blue'].join(' ');
